"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function defaultFilter(r, g, b, a) {
    return a >= 125 &&
        !(r > 250 && g > 250 && b > 250);
}
exports.default = defaultFilter;
//# sourceMappingURL=default.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/node-vibrant/lib/filter/default.js
// module id = 4851
// module chunks = 14